import React, { useState, useEffect } from "react";
import { DetailsList, DetailsListLayoutMode, ColumnActionsMode, SelectionMode, IColumn, ConstrainMode } from '@fluentui/react';
import MainView from "./SiteDetails/MainView";
import { Spinner, SpinnerSize} from '@fluentui/react';
import Api from '../../services/Api';
import { renderDate } from "../../helpers/HelperMethods";

const SiteItemsList = ({isLoading, results, filters, orderedBy, sortItems}) => {
        
    const [items, setItems] = useState(results);

    useEffect(() => {
        if (results) {
            setItems(results);
        }
    }, [results]);

    // _onChangeText = (ev, text) => {
    //     this.setState({
    //         filteredItems: (text
    //             ? this.state.items.filter(i => i.name.toLowerCase().indexOf(text) > -1)
    //             : null)
    //         });
    // };

    // _onColumnClickClient = (ev, column) => {
    //     const { columns, items } = this.state;

    //     const newColumns = columns.slice();
    //     const currColumn = newColumns.filter(currCol => column.key === currCol.key)[0];
    //     newColumns.forEach((newCol) => {
    //       if (newCol === currColumn) {
    //         currColumn.isSortedDescending = !currColumn.isSortedDescending;
    //         currColumn.isSorted = true;
    //       } else {
    //         newCol.isSorted = false;
    //         newCol.isSortedDescending = true;
    //       }
    //     });
    //     const newItems = this._copyAndSort(items, currColumn.fieldName, currColumn.isSortedDescending);

    //     this.setState({
    //         items: newItems,
    //         columns: newColumns
    //     })
    // };
    
    // _copyAndSort = (items, key, isSortedDescending) => {
    //     return items
    //         .slice(0)
    //         .sort((a, b) => {
    //             const val1 = getPropertyValueByString(a, key);
    //             const val2 = getPropertyValueByString(b, key);
    //             return (isSortedDescending ? val1 < val2 : val1 > val2) ? 1 : -1
    //         });
    // }

    const initialColumns: IColumn[] = [
        {
            key: 'title',
            name: 'Site Name',
            fieldName: 'title',
            minWidth: 100,
            maxWidth: 150,
            isRowHeader: false,
            isResizable: true,
            data: 'string',
            isPadded: true
        },
        {
            key: 'url',
            name: 'Site URL',
            fieldName: 'url',
            minWidth: 100,
            maxWidth: 360,
            isResizable: true,
            data: 'string',
            onRender: (item) => _renderUrl(item.url),
            isPadded: true
        },
        {
            key: 'owner',
            name: 'Administrator',
            fieldName: 'owner',
            minWidth: 130,
            maxWidth: 200,
            isResizable: true,
            data: 'string',
            columnActionsMode: ColumnActionsMode.disabled,
            //onRender: (item) => _renderOwners(item.owners), // old view - renders multiple owners
            onRender: (item) => { return item.owner && <div>{ item.owner.email }</div>},
            isPadded: true
        },
        {
            key: 'expirationDate',
            name: 'Expiration Date',
            fieldName: 'expirationDate',
            minWidth: 60,
            maxWidth: 100,
            isResizable: true,
            data: 'number',
            onRender: (item) => {
                return <span>{renderDate(item.expirationDate)}</span>;
            },
            isPadded: true
        },
        {
            key: 'siteStatus',
            name: 'Site Status',
            fieldName: 'siteStatus',
            minWidth: 60,
            maxWidth: 150,
            isResizable: true,
            data: 'string',
            isPadded: true
        },
        {
            key: 'provisioningStatus',
            name: 'Technical Status',
            fieldName: 'provisioningStatus',
            minWidth: 60,
            maxWidth: 150,
            isResizable: true,
            data: 'string',
            isPadded: true
        },
        {
            key: 'externalCollaboration',
            name: 'External Collaboration',
            fieldName: 'externalCollaboration',
            minWidth: 22,
            maxWidth: 50,
            isResizable: true,
            data: 'string',
            onRender: (item) => {
                return <span>{item.externalCollaboration ? 'Yes' : 'No'}</span>;
            },
            isPadded: true
        },
        {
            key: 'confidentiality',
            name: 'Sensitivity Label',
            fieldName: 'confidentiality',
            minWidth: 60,
            maxWidth: 120,
            isResizable: true,
            data: 'string',
            isPadded: true
        },
        {
            key: 'management',
            name: 'Organization',
            minWidth: 30,
            maxWidth: 100,
            isResizable: true,
            data: 'string',
            onRender: (item) => {
                return <span>{item.dimension && item.dimension.management && item.dimension.management.key}</span>;
            },
            isPadded: true,
        },
        {
            key: 'geography',
            name: 'Site Audience',
            minWidth: 100,
            maxWidth: 200,
            isResizable: true,
            data: 'string',
            onRender: (item) => {
                return <span>{item.dimension && item.dimension.geography && item.dimension.geography.value}</span>;
            },
            isPadded: true
        },
        {
            key: 'edit',
            name: 'Actions',
            minWidth: 80,
            maxWidth: 150,
            isResizable: false,
            isIconOnly: true,
            isPadded: true,
            columnActionsMode: ColumnActionsMode.disabled,
            onRender: (item) => {
                return <MainView editedSite={item} callBack={_onEditCallback}  />
            }
        }
    ];

    const _getSiteById = async id => {
        const result = await Api.get(`/Site?id=${id}`);

        return result.data;
    }

    const _onEditCallback = async id => {
        const site = await _getSiteById(id);

        const updatedItems = items.map(x => (x.id === id) ? site : x);

        setItems(updatedItems);
    }

    // const _renderOwners = (owners) => {
    //     return owners.map(x => <div key={x.id}>{x.email}</div>);
    // }

    const _renderUrl = (url) => {
        return <div><a 
                href={url} 
                title={url} 
                target='_blank' 
                style={{color: 'inherit', textDecoration: 'none'}} >
                    {url}
                </a></div>;
    }

    const _onColumnClick = (ev, column) => {
        sortItems(column.key, !column.isSortedDescending);
    }

    const getColumns = (initialColumns) => {
 
        const columns = initialColumns.map(c => {
            c.isFiltered = (filters[c.key] || '').length > 0;
            c.isSorted = orderedBy.fieldName === c.key;
            c.isSortedDescending = c.isSorted ? orderedBy.isDescending : true;
            return c;
        });

        return columns;
    }
    
    const columns = getColumns(initialColumns);    
    const spinner = <Spinner style={{margin: '200px'}} size={SpinnerSize.large} />;

    return (
        <div>
            {   isLoading
                    ? spinner
                    : <DetailsList
                        items={items}
                        columns={columns}
                        layoutMode={DetailsListLayoutMode.justified}
                        isHeaderVisible={true}
                        selectionMode={SelectionMode.none}
                        styles={{root: {width: '100%'}}}
                        onColumnHeaderClick={_onColumnClick}
                        constrainMode={ConstrainMode.unconstrained}
                    />
            }
        </div>
    );
}

export default SiteItemsList


// WEBPACK FOOTER //
// ./src/components/Administration/SiteItemsList.js